import { combineReducers } from "redux"
import { SIGN_OUT } from "../actions"

import Layout from "../layout/reducer"
import authReducer from "./authReducer"
import root from "./rootReducer"
import deviceIdReducer from "./deviceIdReducer"
import productsReducer from "./productsReducer"
import boxReducer from "./boxReducer"
import checkBoxUpdateModalItems from "./checkBoxUpdateModalItems"
import checkBoxSelectDataReducer from "./placeOrderButtonReducer"
import notificationsReducer from "./notificationsReducer"
import productionSchedulesReducer from "./productionSchedules"

const appReducer = combineReducers({
   Layout,
   root,
   userAuth: authReducer,
   deviceId: deviceIdReducer,
   products: productsReducer,
   boxes: boxReducer,
   checkBox: checkBoxUpdateModalItems,
   notifications: notificationsReducer,
   checkBoxSelect: checkBoxSelectDataReducer,
   productionSchedules: productionSchedulesReducer,
})

const rootReducer = (state, action) => {
   if (action.type === SIGN_OUT) {
      const { Layout, deviceId } = state
      state = { Layout, deviceId }
   }

   return appReducer(state, action)
}

export default rootReducer
